import React from 'react';
import PropTypes from 'prop-types';

const FilesStack = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      fill="#B0BAC6"
      d="M10.405 5.25a1.5 1.5 0 0 0-1.06.439L6.44 8.592a1.5 1.5 0 0 0-.439 1.061v6.096a1.5 1.5 0 0 0 1.5 1.5h7.5a1.5 1.5 0 0 0 1.5-1.499V6.749a1.5 1.5 0 0 0-1.5-1.5z"
    ></path>
    <path
      fill="#B0BAC6"
      d="M7.093 3.438A1.5 1.5 0 0 1 8.153 3h4.597a1.5 1.5 0 0 1 1.453 1.125h-3.8c-.696 0-1.363.277-1.856.769L5.644 7.796a2.63 2.63 0 0 0-.769 1.857v5.299a1.5 1.5 0 0 1-1.125-1.453V7.403c0-.398.158-.78.44-1.061z"
    ></path>
    <path
      fill="#B0BAC6"
      d="M4.845 1.189a1.5 1.5 0 0 1 1.06-.44h4.597a1.5 1.5 0 0 1 1.453 1.126h-3.8c-.696 0-1.363.276-1.856.768L3.396 5.547a2.63 2.63 0 0 0-.769 1.856v5.3a1.5 1.5 0 0 1-1.125-1.454V5.153c0-.397.158-.78.44-1.06z"
    ></path>
  </svg>
);

FilesStack.propTypes = {
  size: PropTypes.number,
};

FilesStack.defaultProps = {
  size: 18
};

export default FilesStack;
